export default{
    poseTitle: 'عنوان',
    roomStatus: 'وضعیت',
    poses:'مدیریت دستگاه کارت خوان',
    editPose:'ویرایش دستگاه کارت خوان',
    addPose:'دستگاه کارت خوان جدید',
    searchPoseByUnit : 'جستجو بر اساس واحد',
}